import { deepCopy } from "../../../../utils/FPEUtils";

export const configCoPilotCurrentDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "%position_url%/aircraft/flight?usergroup_id=%user_group_id%&interval_hour=%interval_hour%",
    "cache_busting": true,
    "retain": true,
    "update_interval": 30,
    "auto_update": false//tracking_aircraft_codeが未設定の場合にデータ取得を行わないための設定。tracking_aircraft_codeを設定するタイミングでtrueにする
  }
};

const IMAGES = {
  heli: {
    blue: 'images/contents/map/copilot/heli_blue.svg',
    cyan: 'images/contents/map/copilot/heli_cyan.svg',
    deepSkyBlue: 'images/contents/map/copilot/heli_deepskyblue.svg',
    green: 'images/contents/map/copilot/heli_green.svg',
    hotPink: 'images/contents/map/copilot/heli_hotpink.svg',
    lemonChiffon: 'images/contents/map/copilot/heli_lemonchiffon.svg',
    lime: 'images/contents/map/copilot/heli_lime.svg',
    navy: 'images/contents/map/copilot/heli_navy.svg',
    orange: 'images/contents/map/copilot/heli_orange.svg',
    purple: 'images/contents/map/copilot/heli_purple.svg',
    red: 'images/contents/map/copilot/heli_red.svg',
    yellow: 'images/contents/map/copilot/heli_yellow.svg',
  },
  cessna: {
    blue: 'images/contents/map/copilot/cessna_blue.svg',
    cyan: 'images/contents/map/copilot/cessna_cyan.svg',
    deepSkyBlue: 'images/contents/map/copilot/cessna_deepskyblue.svg',
    green: 'images/contents/map/copilot/cessna_green.svg',
    hotPink: 'images/contents/map/copilot/cessna_hotpink.svg',
    lemonChiffon: 'images/contents/map/copilot/cessna_lemonchiffon.svg',
    lime: 'images/contents/map/copilot/cessna_lime.svg',
    navy: 'images/contents/map/copilot/cessna_navy.svg',
    orange: 'images/contents/map/copilot/cessna_orange.svg',
    purple: 'images/contents/map/copilot/cessna_purple.svg',
    red: 'images/contents/map/copilot/cessna_red.svg',
    yellow: 'images/contents/map/copilot/cessna_yellow.svg',
  },
  navi: {
    blue: 'images/contents/map/copilot/navi_blue.svg',
    cyan: 'images/contents/map/copilot/navi_cyan.svg',
    deepSkyBlue: 'images/contents/map/copilot/navi_deepskyblue.svg',
    green: 'images/contents/map/copilot/navi_green.svg',
    hotPink: 'images/contents/map/copilot/navi_hotpink.svg',
    lemonChiffon: 'images/contents/map/copilot/navi_lemonchiffon.svg',
    lime: 'images/contents/map/copilot/navi_lime.svg',
    navy: 'images/contents/map/copilot/navi_navy.svg',
    orange: 'images/contents/map/copilot/navi_orange.svg',
    purple: 'images/contents/map/copilot/navi_purple.svg',
    red: 'images/contents/map/copilot/navi_red.svg',
    yellow: 'images/contents/map/copilot/navi_yellow.svg',
  },
  other_company: {
    blue: 'images/contents/map/copilot/other_blue.svg',
    cyan: 'images/contents/map/copilot/other_cyan.svg',
    deepSkyBlue: 'images/contents/map/copilot/other_deepskyblue.svg',
    green: 'images/contents/map/copilot/other_green.svg',
    hotPink: 'images/contents/map/copilot/other_hotpink.svg',
    lemonChiffon: 'images/contents/map/copilot/other_lemonchiffon.svg',
    lime: 'images/contents/map/copilot/other_lime.svg',
    navy: 'images/contents/map/copilot/other_navy.svg',
    orange: 'images/contents/map/copilot/other_orange.svg',
    purple: 'images/contents/map/copilot/other_purple.svg',
    red: 'images/contents/map/copilot/other_red.svg',
    yellow: 'images/contents/map/copilot/other_yellow.svg',
  }
}

const COLOR = {
  blue: '#0000FF',
  cyan: '#00FFFF',
  deepSkyBlue: '#00BFFF',
  green: '#008000',
  hotPink: '#FF66CC',
  lemonChiffon: '#FFFACD',
  lime: '#00FF00',
  navy: '#000080',
  orange: '#FFA500',
  purple: '#9933FF',
  red: '#FF0000',
  yellow: '#FFFF00'
}

export const configAircraftLayer = {
  "Name": "aircraft",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 0
        },
        "style" : {
          "default" : {
            "type": "point",
            "point_size": 10,
            "line_color": "#0000FF",
            "point_color": "#0000FF",
            "line_width": 3
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 6
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 24,
            "height" : 24,
            "offset_x" : -12,
            "offset_y" : -12,
            "url" : IMAGES.heli.blue,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'heli'
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 7
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 24,
            "height" : 24,
            "offset_x" : -12,
            "offset_y" : -12,
            "url" : IMAGES.cessna.blue,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'cessna'
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 8
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 18,
            "height" : 18,
            "offset_x" : -9,
            "offset_y" : -9,
            "url" : IMAGES.navi.blue,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'navi'
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 9
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 36,
            "height" : 24,
            "offset_x" : -18,
            "offset_y" : -12,
            "url" : IMAGES.other_company.blue,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'other_company'
          }
        }
      },
      // for alert
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 999990
        },
        "style" : {
          "default" : {
            "type": "point",
            "point_size": 10,
            "line_color": "#FF0000",
            "point_color": "#FF0000",
            "line_width": 3
          }
        },
        "alert": true
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 999996
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 24,
            "height" : 24,
            "offset_x" : -12,
            "offset_y" : -12,
            "url" : IMAGES.heli.red,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'heli'
          }
        },
        "alert": true
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 999997
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 24,
            "height" : 24,
            "offset_x" : -12,
            "offset_y" : -12,
            "url" : IMAGES.cessna.red,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'cessna'
          }
        },
        "alert": true
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 999998
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 18,
            "height" : 18,
            "offset_x" : -9,
            "offset_y" : -9,
            "url" : IMAGES.navi.red,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'navi'
          }
        },
        "alert": true
      },
      {
        "selector": {
          "type": "key_value",
          "key": "current_position_id",
          "value": 999999
        },
        "style" : {
          "default" : {
            "type" : "image",
            "width" : 18,
            "height" : 18,
            "offset_x" : -9,
            "offset_y" : -9,
            "url" : IMAGES.other_company.red,
            "rotation": {
              "property": "heading"
            },
            "image_type": 'other_company'
          }
        },
        "alert": true
      }
    ]
  }
}

export const setConfigAircraftLayerAttribute = (settings, initialized) => {
  let attribute;
  if (!initialized) {
    attribute = configAircraftLayer.Attributes;
  } else {
    attribute = deepCopy(configAircraftLayer.Attributes);
  }
  attribute.features.forEach(f => {
    const def = f.style.default;
    if (def.type === 'image') {
      def.width = settings.iconSize;
      def.height = settings.iconSize;
      def.offset_x = -(settings.iconSize / 2);
      def.offset_y = -(settings.iconSize / 2);
      let color, alertColor;
      switch(f.selector.value) {
        case 6:
        case 999996:
          color = settings.heliIconNormal ? settings.heliIconNormal : 'blue';
          alertColor = settings.heliIconAlert ? settings.heliIconAlert : 'red';
          break;
        case 7:
        case 999997:
          color = settings.cessnaIconNormal ? settings.cessnaIconNormal : 'blue';
          alertColor = settings.cessnaIconAlert ? settings.cessnaIconAlert : 'red';
          break;
        case 8:
        case 999998:
          color = settings.naviIconNormal ? settings.naviIconNormal : 'blue';
          alertColor = settings.naviIconAlert ? settings.naviIconAlert : 'red';
          break;
        case 9:
        case 999999:
          color = settings.otherCompanyIconNormal ? settings.otherCompanyIconNormal : 'blue';
          alertColor = settings.otherCompanyIconAlert ? settings.otherCompanyIconAlert : 'red';
          def.height *= 1.5;
          def.offset_y *= 1.5;
          break;
        default:
          break;
      }
      if (!f.alert) {
        def.url = IMAGES[def.image_type][color];
      } else {
        def.url = IMAGES[def.image_type][alertColor];
      }
    } else if (def.type === 'point') {
      def.point_size = settings.iconSize;
      const color = settings.otherIconNormal ? settings.otherIconNormal : 'blue';
      const alertColor = settings.otherIconAlert ? settings.otherIconAlert : 'red';
      if (!f.alert) {
        def.line_color = COLOR[color];
        def.point_color = COLOR[color];
      } else {
        def.line_color = COLOR[alertColor];
        def.point_color = COLOR[alertColor];
      }
    }
  });

  return attribute;
}

export const configTrackPointLayer = {
  "Name": "trackPoint",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "pointSimplify",
          "value": true
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 10,
            "line_color": "#4d4d4dff",
            "point_color": "#FFFFFF"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "point",
          "value": true
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 10,
            "line_color": "#000000",
            "point_color": "#FFFFFF"
          }
        }
      }
    ]
  }
}

export const configTrackLineLayer = {
  "Name": "trackLine",
  "Renderer": "TrackLine",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "gradation",
          "value": true
        },
        "style": {
          "default": {
            "type": "line",
            "line_method": "GC",
            "line_width": 6,
            "option": "bevel",
            "gradation": [
              {alt: 53000, 'color': 'rgba(106,27,154, 0.8)'},
              {alt: 5000, 'color': 'rgba(0, 0, 128, 0.8)'},
              {alt: 3000, 'color': 'rgba(21, 101, 192, 0.8)'},
              {alt: 2000, 'color': 'rgba(0, 131, 143, 0.8)'},
              {alt: 1000, 'color': 'rgba(0, 128, 0, 0.8)'},
              {alt: 700, 'color': 'rgba(158, 157, 36, 0.8)'},
              {alt: 500, 'color': 'rgba(249, 168, 37, 0.8)'},
              {alt: 300, 'color': 'rgba(239, 108, 0, 0.8)'},
              {alt: 200, 'color': 'rgba(198, 40, 40, 0.8)'},
              {alt: 100, 'color': 'rgba(128, 0, 0, 0.8)'}
            ]
          }
        }
      }
    ]
  }
}
